<script setup lang="ts">
import KpSelectField from '@/components/KpSelectField.vue';
import { WaermeerzeugerWarmwasserCollection } from '@/models/WaermeerzeugerWarmwasser';
import { onMounted, type Ref } from 'vue';

const value: Ref<any> = defineModel();

defineProps<{
    label?: string;
}>();

const coll = new WaermeerzeugerWarmwasserCollection();

onMounted(() => {
    coll.query();
});
</script>
<template>
    <KpSelectField
        :label="label"
        v-model="value"
        :options="coll.getModels()"
        option-label="bezeichnung"
        option-value="id"
    ></KpSelectField>
</template>
